// extracted by mini-css-extract-plugin
export default {"label":"ConnectionLinkModal_label__8Hp-A","action":"ConnectionLinkModal_action__Yt9Sv","tag":"ConnectionLinkModal_tag__3GeaU"};